import { ApiResponse } from '@shared/models';
import { ChemicalElement, ChemicalElementDto } from '@app/store/shared/models';

export class Elements {
    items: ChemicalElement[];
    total: number;

    constructor(response: ApiResponse<ChemicalElementDto[]>) {
        this.items = response.data.map((dto) => new ChemicalElement(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
